import { QueryClientProvider } from "@tanstack/react-query";
import { Outlet, useRouterState } from "@tanstack/react-router";
import { ThemeOverrides } from "@/components/layout/ThemeOverrides";
import { ThemeProvider } from "@/components/layout/ThemeProvider";
import { ErrorBoundary } from "@/components/shared/error-boundary";
import { RouteProgress } from "@/components/shared/route-progress";
import { Toaster } from "@/components/ui/sonner";
import { queryClient } from "@/lib/query";

export function RootLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <ThemeOverrides />
        <RouteProgress />
        <ErrorBoundary resetKey={pathname}>
          <Outlet />
        </ErrorBoundary>
        <Toaster />
      </ThemeProvider>
    </QueryClientProvider>
  );
}
